import { useCallback } from "react";
import { Platform } from "react-native";
import Storage from "@lib/utilities/storage/StorageFunctions";
import AppConstants from "@lib/utilities/Constants";

interface UseHeaderLogicProps {
  navigation: any;
  setNotificationVisible: (visible: boolean) => void;
  setRightPanelVisible: (visible: boolean) => void;
  isConnected: any;
}

export const useHeaderLogic = ({
  navigation,
  setNotificationVisible,
  setRightPanelVisible,
  isConnected,
}: UseHeaderLogicProps) => {
  const handleNotificationPress = useCallback(() => {
    if (isConnected) {
      if (Platform.OS !== "web") {
        Storage.clearData(AppConstants.LocalStoreConstant.BADGE_COUNT);
      }
      setNotificationVisible(true);
    }
  }, [isConnected]);

  const handleProfilePress = useCallback(() => {
    setRightPanelVisible(true);
  }, []);

  const handleNavigation = useCallback(
    async (screenName: string, route: string) => {
      if (isConnected) {
        await Storage.clearData(
          AppConstants.LocalStoreConstant.IS_DATA_LOADED_ONCE
        );
        await Storage.storeData(
          AppConstants.LocalStoreConstant.CURRENT_LOADED_SCREEN,
          screenName
        );
        navigation.navigate(route);
      }
    },
    [isConnected, navigation]
  );

  return {
    handleNotificationPress,
    handleProfilePress,
    handleNavigation,
  };
};
